<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Revisor Técnico"
          directory=""
          :icon="'trello'"
        />
      </div>

      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="
              () => {
                $hub.$emit('reload-table');
              }
            "
          >
            <i data-feather="refresh-ccw" class="pr-2" /> Refrescar
          </button>
        </div>
      </div>

      <div class="col-md-12">
        <app-tab :tabs="tabsHorizontal" type="horizontal" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rt: String,
  },
  data() {
    return {
      app_type: "",
      icon: "settings",
      // tabsHorizontal: [
      //   {
      //     icon: "briefcase",
      //     name: "Analizar Informe para la Comisión",
      //     component: "analyze-report-table",
      //     permission: "",
      //   },
      //   {
      //     icon: "briefcase",
      //     name: "Preparar el Informe Final para la Comisión",
      //     component: "prepare-final-report-commission-table",
      //     permission: "",
      //   },
      //   {
      //     icon: "briefcase",
      //     name: "Recomendar Decisión",
      //     component: "recommend-decision-table",
      //     permission: "",
      //   },
      // ],
    };
  },
  computed: {
    tabsHorizontal() {
      let tabs = [];
      if (this.rt > 0) {
        tabs = [
          {
            icon: "briefcase",
            name: "Analizar Informe para la Comisión",
            component: "analyze-report-table",
            permission: "",
          },
          {
            icon: "briefcase",
            name: "Recomendar Decisión",
            component: "recommend-decision-table",
            permission: "",
          },
        ];
      } else {
        tabs = [
          {
            icon: "briefcase",
            name: "Analizar Informe para la Comisión",
            component: "analyze-report-table",
            permission: "",
          },
          {
            icon: "briefcase",
            name: "Preparar el Informe Final para la Comisión",
            component: "prepare-final-report-commission-table",
            permission: "",
          },
          {
            icon: "briefcase",
            name: "Recomendar Decisión",
            component: "recommend-decision-table",
            permission: "",
          },
        ];
      }
      return tabs;
    },
  },
  created() {
    console.log(this.rt);
  },
  methods: {},
};
</script>
